export { default } from './AnnouncementsPage.js';